'use client';

// ШАПКА СПРАВКИ НА ТЕЛЕФОНЕ В БРАУЗЕРЕ (ТЗ WEB-PARITY-3 К39–К42, кадры iOS K17-help-*): у
// корня — кружок «×» слева и кружок-лупа справа; у раздела — пилюля «‹ Справка»; у статьи —
// пилюля «‹ <раздел>» и кружок «поделиться». Полосы сайта на справке в мобильном вебе нет
// (решение владельца 02.10.2026, В-К7). На широком экране шапка не рисуется (help.css) —
// там страница как была, с шапкой сайта. Компонент — клиентский ради кнопок; разметку
// отдаёт сервер, признак «телефон» решает CSS, поэтому гидрация не расходится.
import type { ReactNode } from 'react';
import { KBareButton, KPill } from '@scriptera/ui/kit';
import { askHelpSearch, HelpSearchButton } from './help-search';

/** «×» корня — ВСЕГДА на главную `/<язык>` (ТЗ HELP-WARM-FIX §6а п.7, владелец 26.10.2026: с раздела «Начало работы» «×»
 *  «закидывает на начало раздела статей»): «×» = выйти из справки; «назад» внутри справки — крошки и «назад» браузера.
 *  Прежнее «назад туда, откуда пришли» (24.10) возвращало в раздел, если в корень пришли из него. */
function closeHelp(home: string): void {
  window.location.assign(home);
}

export function HelpTop({
  locale,
  back,
  closeLabel,
  right,
}: {
  locale: string;
  /** Пилюля «‹ слово» слева (раздел). */
  back?: { href: string; label: string };
  closeLabel: string;
  /** Правый кружок (лупа, «поделиться»); нет — пусто. */
  right?: ReactNode;
}) {
  return (
    <div className="help-top">
      {back ? (
        <HelpBackPill label={back.label} onClick={() => window.location.assign(back.href)} />
      ) : (
        <KBareButton type="button" className="k-round" aria-label={closeLabel} onClick={() => closeHelp(`/${locale}`)}>
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2.4} strokeLinecap="round" aria-hidden>
            <path d="M6 6l12 12M18 6L6 18" />
          </svg>
        </KBareButton>
      )}
      <span className="help-top-sp" />
      {right}
    </div>
  );
}

/** Кружок-лупа шапки корня: раскрывает поле поиска (help-search.tsx). */
export function HelpTopSearch({ label }: { label: string }) {
  return <HelpSearchButton label={label} onClick={askHelpSearch} />;
}

/** ПИЛЮЛЯ «‹ слово» ШАПКИ СПРАВКИ (кадры iOS K17-help-section «‹ Справка», K17-help-article
 *  «‹ Начало работы»): одна на страницу /help и на лист справки в кабинете — пилюля набора KPill
 *  (стекло с тенью, Закон 5 п.8), стрелка и имя уровня, куда ведёт. Прежняя своя разметка
 *  `help-top-pill` снята (пакет М, круг 2). */
export function HelpBackPill({ label, onClick }: { label: ReactNode; onClick: () => void }) {
  return (
    <KPill className="help-back" onClick={onClick}>
      <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2.6} strokeLinecap="round" strokeLinejoin="round" aria-hidden>
        <path d="M15 5l-7 7 7 7" />
      </svg>
      <span>{label}</span>
    </KPill>
  );
}
